/**
 * A custom error for TeaBlocks runtime error that contain information about where (node)
 * the error originates from. These errors are created either by user error or
 * by bugs in the code :/
 */
export class TeaBlocksError extends Error {
    id: string;

    /**
     * Constructor.
     * @param message error message (kid friendly text)
     * @param id the id of the assembly block/state node/diagram node that threw this error.
     */
    constructor(message: string, id: string) {
        super(message);
        this.id = id;
        this.name = 'TeaBlocksError';
    }
}